import React from 'react';
import { graphql, Link } from 'gatsby';
import Img from 'gatsby-image';

import Layout from '../components/layout';
import SEO, { siteUrl, personId, authorRef } from '../components/seo';
import AwesomeSlider from 'react-awesome-slider';
import AwesomeSliderStyles from 'react-awesome-slider/src/styled/fold-out-animation';

class ProjectPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark;
    const siteTitle = this.props.data.site.siteMetadata.title;
    const url = `${siteUrl}/project${this.props.pageContext.slug}`;
    const description = post.frontmatter.description || post.excerpt;
    // console.log(post);
    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          description={description}
          schema={[
            {
              '@type': 'Article',
              '@id': `${url}#article`,
              url,
              mainEntityOfPage: url,
              headline: post.frontmatter.title,
              description,
              datePublished: post.frontmatter.date,
              ...(post.frontmatter.thumbnail && {
                image:
                  siteUrl + post.frontmatter.thumbnail.childImageSharp.fluid.src
              }),
              author: authorRef,
              publisher: { '@id': personId }
            }
          ]}
        />
        <article
          className={`post-content ${post.frontmatter.thumbnail || `no-image`}`}
        >
          <header className="post-content-header">
            <h1 className="post-content-title">{post.frontmatter.title}</h1>
            <p className="post-content-byline">
              By <Link to="/about/">{siteTitle}</Link>
            </p>
          </header>

          {post.frontmatter.description && (
            <p class="post-content-excerpt">{post.frontmatter.description}</p>
          )}

          {post.frontmatter.thumbnail && (
            <div className="post-content-image">
              <Img
                className="kg-image"
                fluid={post.frontmatter.thumbnail.childImageSharp.fluid}
                alt={post.frontmatter.title}
              />
            </div>
          )}

          <div
            className="post-content-body"
            dangerouslySetInnerHTML={{ __html: post.html }}
          />
          <hr />
          {post.frontmatter.pics && post.frontmatter.pics.length > 0 ? (
            post.frontmatter.pics.map(pic => {
              if (!pic) {
                return null;
              }
              return (
                <>
                  <div className="kg-image-card">
                    <Img
                      className="kg-image"
                      fluid={pic.childImageSharp.fluid}
                      alt={post.frontmatter.title}
                    />
                  </div>
                  <hr />
                </>
              );
            })
          ) : (
            <br></br>
          )}

          <footer className="post-content-footer">
            {/* There are two options for how we display the byline/author-info.
        If the post has more than one author, we load a specific template
        from includes/byline-multiple.hbs, otherwise, we just use the
        default byline. */}
          </footer>
        </article>
      </Layout>
    );
  }
}

export default ProjectPostTemplate;

export const pageQuery = graphql`
  query ProjectPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        pics {
          childImageSharp {
            fluid(maxWidth: 1360) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        date
        description
        thumbnail {
          childImageSharp {
            fluid(maxWidth: 1360) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
